import { InjectionToken } from '@angular/core';

export interface DbTypeActionMapping {
	type: string;
	route: string;
	create?: string;
	update?: string;
	remove?: string;
	load?: string;
	db?: string;
}

export const DB_TYPE_ACTION_MAPPING = new InjectionToken<DbTypeActionMapping[]>('DB_TYPE_ACTION_MAPPING');



// WEBPACK FOOTER //
// ./src/app/shared/services/db/db.tokens.ts